var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"411px"},attrs:{"id":"app1"}},[_c('video',{attrs:{"id":"myvideo","controls":"true","height":"100%","width":"100%","muted":""},domProps:{"muted":true},on:{"click":_vm.click}})])}
var staticRenderFns = []

export { render, staticRenderFns }